export const Infotab = [
  {
    headline: "Holiday Home Investment Opportunities",
    img1: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/growth.svg",
    img2: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/maids.svg",
    img3: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/give-money.svg",
    img4: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/plan.svg",
    text1: "Low Cost High Appreciation",
    text2: "Professionally Managed",
    text3: "Guaranteed To Produce Income",
    text4: "We Designed Floor Plans",
    bttn: "EXPLORE INVESTMENT OPPORTUNITIES",
    path: "/explore-investment",
  },
  {
    headline: "Are You A Holiday Home Owner/Manager?",
    img1: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/network.svg",
    img2: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/layout.svg",
    img3: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/flash.svg",
    img4: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/smartphone-call.svg",
    text1: "Get Bookings From 100+ Websites",
    text2: "One Dashboard - Total Control",
    text3: "Instant Book Or Request To Book",
    text4: "Both iOS & Android App Available.",
    bttn: "LIST YOUR PROPERTY",
    path: "/new-dashboard",
  },
];

export const Infotab2 = [
  {
    img1: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/growth.svg",
    text1: "Low Cost High Appreciation",
    path: "/",
  },
  {
    img1: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/growth.svg",
    text1: "Low Cost High Appreciation",
    path: "/",
  },
  {
    img1: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/growth.svg",
    text1: "Low Cost High Appreciation",
    path: "/",
  },
  {
    img1: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/growth.svg",
    text1: "Low Cost High Appreciation",
    path: "/",
  },
  {
    img1: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/growth.svg",
    text1: "Low Cost High Appreciation",
    path: "/",
  },
  {
    img1: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/growth.svg",
    text1: "Low Cost High Appreciation",
    path: "/",
  },
  {
    img1: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/growth.svg",
    text1: "Low Cost High Appreciation",
    path: "/",
  },
  {
    img1: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/growth.svg",
    text1: "Low Cost High Appreciation",
    path: "/",
  },
  {
    img1: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/growth.svg",
    text1: "Low Cost High Appreciation",
    path: "/",
  },
  {
    img1: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/growth.svg",
    text1: "Low Cost High Appreciation",
    path: "/",
  },
  {
    img1: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/growth.svg",
    text1: "Low Cost High Appreciation",
    path: "/",
  },
  {
    img1: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/growth.svg",
    text1: "Low Cost High Appreciation",
    path: "/",
  },
];
